import React, {useEffect, useState, useContext} from "react";
import { useHistory } from "react-router-dom";
import styles from "./processCompare/ProcessCompare.module.scss";
import ProcessCompareSidebar from "./processCompare/ProcessCompareSidebar";
import Graph from "./processMap/Graph";
import ProcessCompareStatisticalView from "./processCompare/ProcessCompareStatisticalView";
import ProcessCompareSideBySideView from "./processCompare/ProcessCompareSideBySideView";
import appContext from "../../../context/appContext";

const ProcessCompare = () => {

    const [activeTab, setActiveTab] = useState({combinedView: true});
    const [loading , setLoading] = useState(true)
    const handleActiveTab = (param) => {
        if (!activeTab[param]) {
            setActiveTab(prevState => ({ [ param ]: !prevState[ param ] }));
        }
    }

    const context = useContext(appContext);

    const history = useHistory();
    useEffect(() => {
        if (activeTab['sideBySideView']) {
            history.push('?view=side-by-side');
        } else if (activeTab['statisticalView']) {
            history.push('?view=statistical-view');
        } else {
            history.push('/process-compare');
        }
    }, [activeTab]);
    return (
        <div className={styles.ProcessCompare}>
            {!loading && <nav>
                <ul className={styles.Tabs}>
                    <li
                        onClick={() => handleActiveTab('combinedView')}
                        className={`d-flex justify-content-center align-items-center ${styles.tab} ${styles.Tab} ${activeTab['combinedView'] ? styles.active : ''}`}>
                        <div className={'d-flex align-items-center justify-content-center'}>
                            <div className={'d-flex'}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.18859 10.2235C5.88701 8.93782 5.88701 7.59978 6.18859 6.31409C6.60618 4.53383 7.99623 3.14378 9.7765 2.72619C11.0622 2.4246 12.4002 2.4246 13.6859 2.72619C15.4662 3.14378 16.8562 4.53383 17.2738 6.3141C17.5754 7.59978 17.5754 8.93782 17.2738 10.2235C16.8562 12.0038 15.4662 13.3938 13.6859 13.8114C12.4002 14.113 11.0622 14.113 9.7765 13.8114M6.18859 10.2235C6.60618 12.0038 7.99623 13.3938 9.7765 13.8114M6.18859 10.2235C5.9987 9.41398 5.92837 8.58371 5.97761 7.75881C5.90798 7.77302 5.83852 7.78825 5.76922 7.8045C4.24328 8.16244 3.05181 9.35391 2.69387 10.8799C2.43538 11.9819 2.43538 13.1288 2.69387 14.2308C3.05181 15.7567 4.24328 16.9482 5.76922 17.3061C6.87124 17.5646 8.01813 17.5646 9.12014 17.3061C10.6461 16.9482 11.8376 15.7567 12.1955 14.2308C12.2117 14.1615 12.227 14.092 12.2412 14.0224C11.4163 14.0716 10.586 14.0013 9.7765 13.8114" stroke="#70789E" stroke-width="1.5"/>
                                </svg>
                            </div>
                            <div className={'ml-1'}>
                                Combined View
                            </div>
                        </div>
                    </li>
                    <li
                        onClick={() => handleActiveTab('sideBySideView')}
                        className={`${styles.tab} ${styles.Tab} ${activeTab['sideBySideView'] ? styles.active : ''}`}>
                        <div className={'d-flex align-items-center justify-content-center'}>
                            <div className={'d-flex'}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.06485 7.39932H16.9352M7.39932 7.83276L7.39932 16.9352M2.79406 12.5413C2.40198 10.8698 2.40198 9.13021 2.79406 7.45869C3.33698 5.14417 5.14417 3.33698 7.45869 2.79406C9.13021 2.40198 10.8698 2.40198 12.5413 2.79406C14.8558 3.33698 16.663 5.14417 17.2059 7.4587C17.598 9.13021 17.598 10.8698 17.2059 12.5413C16.663 14.8558 14.8558 16.663 12.5413 17.2059C10.8698 17.598 9.13021 17.598 7.4587 17.2059C5.14418 16.663 3.33698 14.8558 2.79406 12.5413Z" stroke="#70789E" stroke-width="1.5"/>
                                </svg>
                            </div>
                            <div className={'ml-1'}>
                                Side by Side View
                            </div>
                        </div>
                    </li>
                    <li
                        onClick={() => context.handleDataChartCompare() && handleActiveTab('statisticalView')}
                        className={`${styles.tab} ${styles.Tab} ${!context.handleDataChartCompare() && styles.notAllowed} ${activeTab['statisticalView'] ? styles.active : ''}`}>
                        <div className={'d-flex align-items-center justify-content-center'}>
                            <div className={'d-flex'}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.01715 7.26619C2.5928 5.05879 4.35158 3.37001 6.56015 2.90403L6.98217 2.81498C8.97267 2.39501 11.0274 2.39501 13.0179 2.81498L13.4399 2.90403C15.6485 3.37001 17.4072 5.05879 17.9829 7.26619C18.4502 9.05806 18.4502 10.9419 17.9829 12.7338C17.4072 14.9412 15.6485 16.63 13.4399 17.096L13.0179 17.185C11.0274 17.605 8.97267 17.605 6.98217 17.185L6.56015 17.096C4.35158 16.63 2.5928 14.9412 2.01715 12.7338C1.54987 10.9419 1.54987 9.05806 2.01715 7.26619Z" stroke="#70789E" stroke-width="1.5"/>
                                    <path d="M5 10H6.66667L8.33333 12.5L11.6667 7.5L13.3333 10H15" stroke="#70789E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <div className={'ml-1'}>
                                Statistical View
                            </div>
                        </div>
                    </li>
                    <li className={`${styles.presentationSlider}`} role="presentation"></li>
                </ul>
            </nav>}
            {
                activeTab['combinedView'] && (
                    <>
                                <div className="container-fluid p-24">
                                    <Graph type="processCompare" processCompare loadMap={() => setLoading(false)}/>
                                </div>
                        <ProcessCompareSidebar/>
                    </>
                )
            }
            {
                activeTab['sideBySideView'] && (
                    <>
                        <ProcessCompareSideBySideView/>
                    </>
                )
            }
            {
                activeTab['statisticalView'] && (
                    <>
                        <ProcessCompareStatisticalView/>
                    </>
                )
            }
        </div>
    )
}

export default ProcessCompare;